import i18next from "i18next";

export const translateAmenties = (val: any): string => {
    return i18next.t(val);
}